var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { staticClass: "searchbar" }, [
    _c(
      "div",
      { staticClass: "input-group", class: { expanded: _vm.visible } },
      [
        _vm.visible
          ? _c("input", {
              ref: "searchInput",
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: "Search",
                "aria-label":
                  "Wpisz frazę i zatwierdź w celu rozpoczęcia wyszukiwania.",
                "aria-describedby": "button-addon2",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-primary",
            class: { "btn-ghost": !_vm.visible },
            attrs: {
              type: "button",
              "aria-label": "Wybierz aby wyświetlić pole formularza",
              id: "button-addon2",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggle.apply(null, arguments)
              },
            },
          },
          [_c("i", { staticClass: "bi bi-search" })]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }